/**
 * Утилиты для работы с API
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aiapi.skillslab.center/api';

/**
 * Базовый запрос к API
 * @param {string} endpoint - Конечная точка API (например, '/projects/1/')
 * @param {Object} options - Опции для fetch (method, headers, body и т.д.)
 * @returns {Promise} - Промис с ответом от API
 */
export const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

/**
 * GET запрос к API
 * @param {string} endpoint - Конечная точка API
 * @returns {Promise} - Промис с данными
 */
export const apiGet = (endpoint) => {
  return apiRequest(endpoint, {
    method: 'GET',
  });
};

/**
 * Загрузка конфигурации проекта
 * @param {number} projectId - ID проекта
 * @returns {Promise} - Промис с конфигурацией проекта
 */
export const getProjectConfig = async (projectId = 1) => {
  return apiGet(`/projects/${projectId}/`);
};

